module.exports = __webpack_public_path__ + "static/media/nft.aca81590.svg";